<template>
  <div class="hello">

    <template v-if="showSpinner">
      <i class="fa fa-circle-o-notch fa-spin fa-5x fa-fw spinner"></i>
    </template>

    <div class="container" v-if="!showSpinner">

     <div class="item col-md-6">

       <a href="https://www.visity.app/" target="_blank" class="link">
         <img id="image" src="../assets/VISITY.png" style="height:10em">
       </a>
       <!-- <br>
       <br> -->
       <p class="text-left">
         <!-- Dear Customer,<br><br>
         In light of COVID-19, we have introducted a FREE plan to help businesses get started with Visity's Smart & Contactless Visitor Management application.<br><br> -->
         <!-- Due to increase in demand during the past few days our implementation and onboarding times have increased from 1 working day to 4 working days. -->
        <!-- To ensure a smooth implementation and onboarding process please share the following information and a representative from our sales team will get in touch with you within 24 hours of filling this form. -->
        <!-- <br><br> -->
        <!-- Stay safe! -->
       </p>

       <h2>Free Sign Up</h2>
       <br>
        <form class="CurfewPassForm text-center" @submit.prevent="SendOTP" v-if="showForm && !showOTP">

          <div class="form-group col-md-12 text-left">
            <label for="exampleInputEmail1">Company Name <b>*</b></label>
            <input type="text" class="form-control" v-model="FormInfo.CompanyName" placeholder="" required>
          </div>

          <div class="form-group col-md-12 text-left">
            <label for="exampleInputEmail1">Name <b>*</b></label>
            <input type="text" class="form-control" v-model="FormInfo.CustomerName" placeholder="First Name Last Name" required>
          </div>

            <div class="form-group col-md-12 text-left">
              <label for="exampleInputEmail1">Mobile <b>*</b></label>
              <input type="tel" class="form-control" v-model="FormInfo.CustomerMobile" minlength="10" maxlength="10" placeholder="10 Digit Mobile Number" required>
            </div>

            <div class="form-group col-md-12 text-left">
              <label for="exampleInputEmail1">City <b>*</b></label>
              <input type="text" class="form-control" v-model="FormInfo.City" placeholder="" required>
            </div>

            <div class="form-group col-md-12 text-left">
              <label for="exampleInputEmail1">Email</label>
              <input type="email" class="form-control" v-model="FormInfo.Email" placeholder="">
            </div>

            <div class="form-group col-md-12 button">
              <input type="submit" value="Next" class="btn btn-primary btn-block" />
              <br>
            </div>

        </form>

        <form class="CurfewPassForm" @submit.prevent="Submit" v-if="showOTP">

          <div class="form-group col-md-12">
            <label for="exampleInputEmail1">Enter OTP <b>*</b></label>
            <input type="tel" class="form-control" v-model="FormInfo.OTP" minlength="6" maxlength="6" placeholder="6 Digit OTP" required>
          </div>

          <div class="form-group col-md-12 button">
            <input type="submit" value="Verify" class="btn btn-primary btn-block" />
            <br>
            <!-- <template v-if="showSpinner2">
              <p>Do Not Refresh<br>It will only take a minute.<br> Please wait...</p>
              <i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw spinner"></i>
            </template> -->
          </div>

        </form>

            <p v-if="shopClose" class="text-center shopClose">
              Sorry, business is closed.
            </p>

        <br>

     </div>


    </div>

    <!-- <p>Powered By:</p>
    <a href="https://www.visity.app/" target="_blank" class="link">
      <img id="image" src="/static/logo.png" style="height:3.5em">
    </a> -->


  </div>
</template>

<script>

import { db } from '../main'
import Swal from 'sweetalert2'
import firebase from 'firebase'
import moment from 'moment';
import axios from 'axios';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      BusinessInfo: {},
      TempObj: {},
      FormInfo: {},
      TokenInfo: {},
      Waiting: 0,
      OTP: '',
      etokenURL: 'www.visity.app',
      showForm: true,
      showOTP: false,
      showQRCode: false,
      showSpinner: true,
      showSpinner2: false,
      showSlot: false,
      shopClose: false,
      size: 200,
      value: "test",
      AvailableSlots: [],
      BookedSlots: [],
      Slot: '',
      SlotVal: ''
    }
  },
  mounted(){
    console.log("Component Mounted");

    this.showSpinner = false;

  },
  methods: {
    SendOTP(){

      this.showOTP = true;

      console.log("--- Send OTP ---");

      this.OTP = Math.floor(100000 + Math. random() * 900000);
      console.log("OTP: ",this.OTP);

      var sms = "Verification Code is "+this.OTP+" for Visity Sign Up.";

      let data = {
        Mobile: this.FormInfo.CustomerMobile,
        SMS: sms
      };

      console.log("SMS Payload: "+JSON.stringify(data));

        axios.post("https://us-central1-visity-fcbd6.cloudfunctions.net/widgets/send-sms-notification", data).then((res) => {
          console.log("Send SMS Success: ",res);
        }).catch((e) => {
          console.log("Send SMS Error: ",e);
        });

    },
    Submit(){

      console.log("OTP: ", this.OTP);
      console.log("Entered OTP: ", this.FormInfo.OTP);

      if(this.FormInfo.OTP == this.OTP){

        // this.showSpinner = true;
        console.log("OTP Verified");

        this.FormInfo.AddedOn = moment().format();

        console.log("FormInfo: "+JSON.stringify(this.FormInfo));

                db.collection("website-leads")
                  .add(this.FormInfo)
                  .then((res) => {
                    console.log(res);
                    console.log("Id: "+res.id)
                    console.log("Lead Added");

                    this.SendSMS();
                    this.SendSMS2();

                    Swal.fire("Thank you! Our Sales Representative will get in touch with you within 24 hours.");

                  });

      }else{
        Swal.fire("Incorrect OTP. Please Try Again.");
      }


    },
    SendSMS(){
      console.log("--- Send SMS ---");

      var sms = "[WEBSITE NEW LEAD]\n"+this.FormInfo.CompanyName+"\n"+this.FormInfo.CustomerName+"\n"+this.FormInfo.CustomerMobile+"\n"+this.FormInfo.City+"\n"+this.FormInfo.Email;

      let data = {
        Mobile: '8128332291',
        SMS: sms
      };

      console.log("SMS Payload: "+JSON.stringify(data));

        axios.post("https://us-central1-visity-fcbd6.cloudfunctions.net/widgets/send-sms-notification", data).then((res) => {
          console.log("Send SMS Success: ",res);

          this.FormInfo.CompanyName = "";
          this.FormInfo.CustomerName = "";
          this.FormInfo.CustomerMobile = "";
          this.FormInfo.City = "";
          this.FormInfo.Email = "";

        }).catch((e) => {
          console.log("Send SMS Error: ",e);
        });

    },
    SendSMS2(){
      console.log("--- Send SMS to Customer---");

      var sms = "[VISITY]\nHi "+this.FormInfo.CustomerName+",\nThank you for Signing Up for Visity. A representative from our team will get in touch with you shortly. You may also reach out to us at 9426801996. Have a nice day & stay safe."

      let data = {
        Mobile: this.FormInfo.CustomerMobile,
        SMS: sms
      };

      console.log("SMS Payload: "+JSON.stringify(data));

        axios.post("https://us-central1-visity-fcbd6.cloudfunctions.net/widgets/send-sms-notification", data).then((res) => {
          console.log("Send SMS Success: ",res);

          this.FormInfo.CompanyName = "";
          this.FormInfo.CustomerName = "";
          this.FormInfo.CustomerMobile = "";
          this.FormInfo.City = "";
          this.FormInfo.Email = "";
          this.showOTP = false;

        }).catch((e) => {
          console.log("Send SMS Error: ",e);
        });

    },
    DisplayQRCode(){

      this.showSpinner = false;
      this.showQRCode = true;

      this.value = this.$route.query.id;
      console.log("BusinessId: "+this.value);

      console.log("Get Business");

      db.collection('etoken-business')
        .doc(this.value)
        .get()
        .then(doc => {

            console.log(doc.data());

            this.BusinessInfo.BusinessId = doc.id;
            this.BusinessInfo.Name = doc.data().Name;
            this.BusinessInfo.Address = doc.data().Address;
            this.BusinessInfo.Contact = doc.data().Contact;
            this.BusinessInfo.NoticeBoard = doc.data().NoticeBoard;
            this.BusinessInfo.Mobile = doc.data().Mobile;
            this.BusinessInfo.Poc = doc.data().Poc;
            this.BusinessInfo.Open = doc.data().Open;
            this.BusinessInfo.WaitTime = doc.data().WaitTime;

            console.log(this.BusinessInfo);

            this.TokenInfo.Name = doc.data().Name;
            this.TokenInfo.Address = doc.data().Address;
            this.TokenInfo.Contact = doc.data().Contact;

        })
        .catch((e) => {
          console.log('Error:', (e));
        });

    },
    AddSlot(){
      console.log(this.SlotVal);

      db.collection("appointment-client")
     .doc("ArYKq50UU77makJkRzyE")
     .update({Sunday:[
       {max:2, time:"9:00 AM"},
       {max:2, time:"9:30 AM"},
       {max:2, time:"10:00 AM"},
       {max:2, time:"10:30 AM"},
       {max:2, time:"11:00 AM"},
       {max:2, time:"11:30 AM"},
       {max:2, time:"12:00 PM"},
       {max:2, time:"12:30 PM"},
       {max:2, time:"1:00 PM"},
       {max:2, time:"1:30 PM"},
       {max:2, time:"2:00 PM"},
       {max:2, time:"2:30 PM"},
       {max:2, time:"3:00 PM"},
       {max:2, time:"3:30 PM"}
     ]})
     .then(() => {
     //   swal("Data has been added successfully  :)");
       console.log('Data Updated - Success');
     })
     .catch(error => {
         console.error("Error: ", error);
     });

    }
  },
  components: {
    QrcodeVue
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.container{
     display: flex;
     flex-direction: row;
     align-items: center;
     align-content: center;
     justify-content: center;
     /* height: 80%; */
     /* border: 1px solid red; */
  }

  .item{
     align-self: center;
     align-items: center;
     align-content: center;
     justify-content: center;
  }

  .item2{
     align-self: center;
     align-items: center;
     align-content: center;
     justify-content: center;
  }

  #title{
   font-weight: 200;
   font-size: 2em;
  }

  #footerMsg{
    font-size: 0.7em;
    font-style: italic;
  }

  #message{
    text-align: left;
    /* padding: em; */
  }

  .CurfewPassForm{
    text-align: left;
  }

  .button{
    text-align: center;
  }

  .spinner{
    color: #38b6ff;
  }

  .lineHeight{
    line-height: 1em;
  }

  .shopClose{
    font-size: 1.4em;
    color: red;
  }

  .footer{
    margin-left: 1em;
    margin-right: 1em;
  }

  .Waiting{
    font-size: 1em;
    color: green;
  }

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue